import React, { useState } from 'react';
import '../styles/GraphSearch.css';
import { searchUser } from '../api/graph';

// Search reveals ONLY your first step. No names along the path; the target's
// name is shown only if they are your own direct link.
function GraphSearch() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setResult(null);
    try {
      const searchResult = await searchUser(email);
      setResult(searchResult);
    } catch (err) {
      setError(err.message || 'Search failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="graph-search-container">
      <form onSubmit={handleSearch} className="search-form">
        <div className="search-input-group">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Search by email (e.g., name@company.com)"
            required
            disabled={loading}
          />
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? '⏳ Searching…' : '🔍 Search'}
          </button>
        </div>
      </form>

      {error && <div className="error-message">{error}</div>}

      {result && (
        <div className={`search-result ${result.found ? 'found' : 'not-found'}`}>
          {!result.found ? (
            <>
              <h3>Not in your network</h3>
              <p className="result-note">
                This person can't be reached through your trusted links. You only ever see
                your own connections.
              </p>
            </>
          ) : result.direct ? (
            <>
              <h3>✅ Directly connected</h3>
              <p className="result-note">
                {result.firstStep?.name || result.targetEmail} is one of your direct links.
              </p>
            </>
          ) : (
            <>
              <h3>Reachable in {result.distance} steps</h3>
              <p className="result-lead">
                Start with <strong>{result.firstStep?.name || 'your contact'}</strong> — your direct link.
              </p>
              <p className="result-note">
                We don't show anyone else on the path. The intro travels one trusted hop at a
                time, and each person chooses to pass it on.
              </p>
              {/* "Ask {firstStep} to pass it on" is wired in the intro-relay step. */}
            </>
          )}
        </div>
      )}

      <div className="search-info">
        <h4>💡 How it works:</h4>
        <ul>
          <li>Enter anyone's email address</li>
          <li>We tell you how many steps away they are</li>
          <li>You only ever see your own direct contact to start with</li>
          <li>No names along the path — privacy by design</li>
        </ul>
      </div>
    </div>
  );
}

export default GraphSearch;
